import { Component, OnInit } from '@angular/core';

import moment from 'moment';

import { GuiaMedicaSearchParameter } from 'src/app/shared/model/search/guia-medica-search-parameters.model';
import { GuiaMedica } from 'src/app/shared/model/guia-medica.model';
import { Pageable } from 'src/app/shared/model/pageable.model';
import { AtendimentoService } from './atendimento.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/seguranca/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({templateUrl: './atendimento.component.html', styleUrls: ['./atendimento.component.css']})
export class AtendimentoComponent implements OnInit {

  filters: GuiaMedicaSearchParameter;
  listaGuiasMedicas: GuiaMedica[];

  pageable: Pageable;
  labels: any = { previousLabel: '', nextLabel: '' };

  identificadorGuiaExclusao: number;
  urlManual: string;

  constructor(private modalService: NgbModal, private atendimentoService: AtendimentoService,
    private toast: ToastrService, private authService: AuthService) {}

  ngOnInit() {
    // Inicializando o pageable com valores padrões.
    this.pageable = new Pageable();

    // Inicializando o filters com valores padrões.
    this.filters = new GuiaMedicaSearchParameter();

    // Buscar guias médicas.
    this.getGuiasMedicas();

    this.urlManual = this.authService.getLoggedUser().perfil === 2 ?
      '/assets/download/Manual_GPM.pdf' :
      '/assets/download/Manual_Prestador.pdf';
  }

  /**
   * Método para desabilitar os botoes para os prestadores caso o atendimento tenha sido finalizado.
   * @param atendimentoFinalizado status para saber se o atendimento foi finalizado
   */
  exibirBotoes(atendimentoFinalizado: boolean): boolean {
    return (this.authService.getLoggedUser().perfil === 1 || this.authService.getLoggedUser().perfil === 4) && atendimentoFinalizado;
  }

  /**
   * Método responsável por setar os valores dos filtros de datas.
   * @param customDateSelectionEvent evento com as datas selecionadas no componente.
   */
  setPeriodDateFilter(customDateSelectionEvent: any) {
    this.filters.dataInicio = moment(customDateSelectionEvent[0]).set({hour: 0, minute: 0, second: 0}).toDate();
    this.filters.dataFim = moment(customDateSelectionEvent[1]).set({hour: 23, minute: 59, second: 59}).toDate();
  }

  // Método responsável pelo filtro da table.
  buscarGuiasMedicas() {
    this.pageable.page = 1;
    this.getGuiasMedicas();
  }

  // Método responsável pelo evento de paginação da table.
  pageChanged(event) {
    this.pageable.page = event;
    this.getGuiasMedicas();
  }

  /**
   * Método responsável por realizar a exclusão da guia médica.
   * @param guiaId id da guia médica que o usuário selecionou.
   */
  excluirGuia(guiaId: number) {
    this.atendimentoService.excluir(guiaId).subscribe(
      () => {
        this.toast.success('Guia médica excluída com sucesso!');
        this.getGuiasMedicas();
      },
      (responseError) => this.toast.error('Erro ao excluir, tente novamente!')
    );

    // Fechar o modal.
    this.modalService.dismissAll();
  }

  /**
   * Método responsável por montar o modal de confirmação da exclusão do atendimento.
   * @param content dados do template do modal.
   * @param guiaId id da guia médica que o usuário selecionou.
   */
  modalExclusaoGuia(content, guiaId) {
    this.identificadorGuiaExclusao = guiaId;
    this.modalService.open(content, { size: 'lg' });
  }

  // Método responsável por buscar a lista de guias.
  private getGuiasMedicas() {
    this.atendimentoService.listarGuias(this.pageable, this.filters).subscribe(
      (dados) =>  {
        this.pageable.totalElements = dados.totalElements;
        this.listaGuiasMedicas = dados.content;
      },
      errorResponse => this.toast.error(errorResponse.error.mensagemUsuario)
    );
  }
}
